<template>
    <div class="message-item__content--image">
        <div class="image">
            <img
                :src="url"
                :alt="fileName"
                class="viewer"
                @click.stop="previewImage" />
        </div>
    </div>
</template>

<script>
    import { VIEWER_UPDATE } from '@/constants/pub_sub'
    import previewImageMixin from '../../mixins/preview_image'

    export default {
        name: 'MessageContentImage',
        mixins: [
            previewImageMixin
        ],
        props: {
            url: {
                type: String,
                required: true
            },
            fileName: {
                type: String
            }
        },
        mounted () {
            // PC 端 viewerjs 可通过“← →”按键查看所有图片，故 update
            if (this.$eventBus.isDesktop) {
                this.$eventBus.$emit(VIEWER_UPDATE)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .image {
        min-width: 80px;
        // border: 4px solid #E6E6E6;
        @include radius(.5);

        img {
            max-width: 100%;
            max-height: 300px;
            object-fit: contain;
            @include radius(.5);
        }
    }

    // .message-item--user {
    //     .image {
            // border-color: $primary-color;
            // background-color: $primary-color;

            // &:active {
            //     border-color: $primary-color-darken-bg;
            //     background-color: $primary-color-darken-bg;
            // }
    //     }
    // }

    // .message-item--service {
    //     .image {
            // border-color: #E6E6E6;
            // background-color: #E6E6E6;

            // &:active {
                // border-color: darken(#ffffff, 7%);
                // background-color: darken(#ffffff, 7%);
            // }
    //     }
    // }
</style>
